import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import PageLayout from '../../components/common/page-layout';
import { ModalContext } from '../../contexts/modal';
import ProformasTable from '../../components/tables/proformas-table';
import NewPerformaForm from '../../components/sales/new-performa-form';
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';

export default function Invoices() {
  const { setOpen, setContent, setTitle } = useContext(ModalContext);
  const [onlyActives, setOnlyActives] = useState(true);
  function openModelModal() {
    const cont = <NewPerformaForm />;
    setContent(cont);
    setTitle('سفارش جدید');
    setOpen(true);
  }

  return (
    <PageLayout pageTitle="سفارش‌ها">
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} lg={9}>
          <Stack direction="row" justifyContent="space-between">
            <Button variant="contained" color="primary" sx={{ mb: 3 }} onClick={openModelModal}>
              ثبت سفارش جدید
            </Button>
            <FormControlLabel
              control={
                <Switch checked={onlyActives} onChange={(e) => setOnlyActives(e.target.checked)} />
              }
              label={
                <Typography fontSize="small" color="textSecondary">
                  فقط سفارش‌های در جریان
                </Typography>
              }
              labelPlacement="end"
            />
          </Stack>
          <ProformasTable onlyActives={onlyActives} />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
